<template>
  <div class="main-box">
    <div class="app">
      <div v-if="tabName == 'baseInfo'">
        <div class="title">
          旅游资源单体采集
        </div>
        <div class="contentCal">
          <div class="form1-box">
            <Card style="margin-bottom: 10px">
              <p slot="title">
                <Icon type="ios-photos" style="color: #2d8cf0;" />
                基本信息
              </p>
              <Form
                ref="addBaseForm"
                :label-width="150"
                label-position="left"
                :rules="baseRule"
                inline
                :model="gatherForm"
              >
                <Row>
                  <Col :span="12">
                    <FormItem label="单体序号" prop="monomerId">
                      <Input
                        v-model="gatherForm.monomerId"
                        clearable
                        style="width: 100%"
                        disabled="false"
                        @blur="joinCode"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="单体名称" prop="monomerName" class="basic-type">
                      <Input v-model="gatherForm.monomerName" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="经度" prop="longitude" class="basic-type">
                      <Input
                        :max="180"
                        :min="-180"
                        v-model="gatherForm.longitude"
                        clearable
                        disabled="false"
                        @on-blur="joinCode"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="纬度" prop="latitude" class="basic-type">
                      <Input
                        :max="90"
                        :min="-90"
                        v-model="gatherForm.latitude"
                        clearable
                        disabled="false"
                        @on-blur="joinCode"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="是否属新发现" prop="newFind">
                      <RadioGroup v-model="gatherForm.newFind" disabled="false">
                        <Radio :label="1" disabled="false">是</Radio>
                        <Radio :label="2" disabled="false">否</Radio>
                      </RadioGroup>
                    </FormItem>
                  </Col>

                  <Col :span="12">
                    <FormItem label="主类型" prop="mainType" class="right-form-box">
                      <Select
                        v-model="gatherForm.mainType"
                        @on-change="giveSecondArr"
                        disabled="false"
                      >
                        <Option v-for="item in typeArr" :value="item.key" :key="item.key">{{
                          item.value
                        }}</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="亚类型" prop="subtype">
                      <Select
                        v-model="gatherForm.subtype"
                        @on-change="giveBasicArr"
                        disabled="false"
                      >
                        <Option v-for="item in secondArr" :value="item.key" :key="item.key">{{
                          item.value
                        }}</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="基本类型" prop="basicType" class="basic-type">
                      <Select
                        v-model="gatherForm.basicType"
                        disabled="false"
                        @on-change="BasicInfo"
                      >
                        <Option v-for="item in basicArr" :value="item.key" :key="item.key">{{
                          item.value
                        }}</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="行政位置" prop="administrativeLocation" class="basic-type">
                      <Input
                        v-model="gatherForm.administrativeLocation"
                        placeholder="输入经纬度之后，行政位置自动生成"
                        clearable
                        disabled="false"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="所属行政区划" prop="areaName" class="basic-type">
                      <Input
                        v-model="gatherForm.areaName"
                        placeholder="输入经纬度位置之后，所属行政区自动生成"
                        clearable
                        disabled="false"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="单体代码" prop="code">
                      <Input
                        v-model="gatherForm.code"
                        placeholder="单体代码自动生成"
                        clearable
                        disabled="false"
                        @blur="joinCode"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="其他代码">
                      <Input v-model="otherCode" clearable disabled="false" />
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
          <div class="form1-box">
            <Card style="margin-bottom: 10px">
              <p slot="title">
                <Icon type="ios-photos" style="color: #2d8cf0" />
                媒体资源
              </p>
              <Row>
                <Col :span="24">
                  <div class="form2-title">图片资源</div>
                  <Upload
                    multiple
                    type="drag"
                    :on-success="uploadPhotoSuccess"
                    :accept="uploadPhotoType"
                    action="/zituSpace/common/uploadFile"
                    v-if="!disabled"
                    ref="photoUpload"
                  >
                    <div style="padding: 20px 0">
                      <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                      <p>在此上传图片，可支持拖拽上传</p>
                    </div>
                  </Upload>
                  <!-- 这里加图片预览的 -->
                  <viewer
                    class="viewer-box"
                    v-if="gatherForm && gatherForm.imageList && gatherForm.imageList.length > 0"
                  >
                    <img
                      v-for="item in gatherForm.imageList"
                      :src="item.url"
                      :key="item.id"
                      class="viewer-item"
                    />
                  </viewer>
                  <div
                    v-if="isShowNull"
                    style="
                      margin-left: 3rem;
                      font-size: 14px;
                      margin-bottom: 1rem;
                    "
                  >
                    暂无图片资源
                  </div>
                </Col>
                <Col :span="24">
                  <div class="form2-title">视频资源</div>
                  <Upload
                    multiple
                    type="drag"
                    :on-success="uploadVideoSuccess"
                    :accept="uploadVideoType"
                    action="/zituSpace/common/uploadFile"
                    v-if="!disabled"
                    ref="videoUpload"
                  >
                    <div style="padding: 20px 0">
                      <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                      <p>在此上传视频，可支持拖拽上传</p>
                    </div>
                  </Upload>
                  <video
                    class="video-js vjs-default-skin vjs-big-play-centered video-box viewer-box"
                    preload="auto"
                    ref="video"
                    autoplay="false"
                    controls
                    v-if="gatherForm && gatherForm.videoList && gatherForm.videoList.length > 0"
                  >
                    <source
                      v-for="(item, index) in gatherForm.videoList"
                      ref="video"
                      :src="item.url"
                      :key="index"
                    />
                  </video>
                  <div v-if="isShowNull" style="margin-left: 3rem; font-size: 14px">
                    暂无视频资源
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
          <div class="form1-box">
            <Card style="margin-bottom: 10px">
              <p slot="title">
                <Icon type="ios-photos" style="color: #2d8cf0" />
                性质特征
              </p>
              <div class="feature-info">
                单体性质、形态、结构、组成成分的外在表现和内在因素，以及单体生成过程、演化历史、人事影响等主要环境因素
              </div>
              <Form
                ref="addPropertyForm"
                :label-width="150"
                label-position="left"
                :rules="propertyRule"
                :model="gatherForm"
                inline
              >
                <div class="text-area-box22">
                  <Input
                    v-model="gatherForm.relatedThings"
                    clearable
                    type="textarea"
                    :rows="5"
                    class="text-area-box"
                    disabled="false"
                  />
                </div>
              </Form>
            </Card>
          </div>
          <div class="form1-box">
            <Card style="margin-bottom: 10px">
              <p slot="title">
                <Icon type="ios-photos" style="color: #2d8cf0" />
                特征数据
              </p>
              <!-- <a href="#" slot="extra" @click.prevent="addtzsj">
                <Icon type="ios-add-circle-outline" style="font-size: 24px" />
              </a> -->
              <Form
                ref="addFeatureDataForm"
                :label-width="150"
                :rules="developRule"
                :model="gatherForm"
                label-position="left"
                inline
              >
                <Row type="flex" v-for="(nav, index) in gatherForm.featureDataList" :key="index">
                  <Col :span="12">
                    <FormItem label="特征名称" prop="planFeature">
                      <Input v-model="nav.planFeature" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="特征值" prop="planFeatureValue" class="right-form-box">
                      <Input v-model="nav.planFeatureValue" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <!-- <Col :span="2"> -->
                  <!-- <Icon
                      type="md-trash"
                      class="delCal"
                      @click="deleteItemFeature(index)"
                    /> -->
                  <!-- </Col> -->
                </Row>
              </Form>
            </Card>
          </div>

          <div class="form1-box">
            <Card style="margin-bottom: 10px">
              <p slot="title">
                <Icon type="ios-photos" style="color: #2d8cf0" />
                旅游区域
              </p>
              <div class="feature-info">
                单体所在地区的具体部位、进出交通、与周边旅游集散地和主要旅游区[点]之间关系
              </div>
              <Form
                ref="addFamousForm"
                :label-width="180"
                label-position="left"
                :rules="famousRule"
                :model="gatherForm"
                inline
              >
                <FormItem label="对外道路情况" prop="externalRoad">
                  <Select
                    v-model="gatherForm.externalRoad"
                    disabled="false"
                    style="width: 100%"
                    multiple
                    clearable
                  >
                    <Option v-for="item in roadConditionArr" :value="item.value" :key="item.id">{{
                      item.title
                    }}</Option>
                  </Select>
                </FormItem>
                <FormItem label="周边市/县名称" prop="ambitusCity" class="develop-box">
                  <Input v-model="gatherForm.ambitusCity" clearable disabled="false" />
                </FormItem>
                <FormItem label="周边市县/距离(公里)">
                  <Input v-model="gatherForm.ambitusCityDistance" clearable disabled="false" />
                </FormItem>
                <FormItem label="周边旅游集散地名称" prop="centreName" class="develop-box">
                  <Input v-model="gatherForm.centreName" clearable disabled="false" />
                </FormItem>
                <FormItem label="周边旅游集散地距离(公里)">
                  <Input v-model="gatherForm.centreDistance" clearable disabled="false" />
                </FormItem>
                <FormItem label="周边旅游区名称" class="develop-box">
                  <Input v-model="gatherForm.touristAreaName" clearable disabled="false" />
                </FormItem>
                <FormItem label="周边旅游区距离(公里)">
                  <Input v-model="gatherForm.touristAreaDistance" clearable disabled="false" />
                </FormItem>
                <br />
                <FormItem label="其他说明" prop="otherInstructionsOne" class="qtsm">
                  <Input
                    v-model="gatherForm.otherInstructionsOne"
                    clearable
                    type="textarea"
                    :rows="8"
                    disabled="false"
                  />
                </FormItem>
              </Form>
            </Card>
          </div>
          <div class="form2-box">
            <Card style="margin-bottom: 10px">
              <p slot="title">
                <Icon type="ios-photos" style="color: #2d8cf0" />
                开发现状
              </p>
              <div class="feature-info">单体保存现状、保护措施、开发情况</div>
              <Form
                ref="addProtectForm"
                :label-width="150"
                :rules="protectRule"
                :model="gatherForm"
                label-position="left"
                inline
                style="width: 100%"
              >
                <Row type="flex">
                  <Col :span="12">
                    <FormItem label="单体保存现状" prop="preservationStatus">
                      <Select
                        v-model="gatherForm.preservationStatus"
                        disabled="false"
                        style="width: 100%"
                      >
                        <Option v-for="item in protectStatus" :value="item" :key="item">{{
                          item
                        }}</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="是否已开发" prop="developed" class="develop-box">
                      <RadioGroup
                        v-model="gatherForm.developed"
                        disabled="false"
                        style="width: 100%"
                      >
                        <Radio :label="1" disabled="false">是</Radio>
                        <Radio :label="2" disabled="false">否</Radio>
                      </RadioGroup>
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="保护措施情况" prop="protective">
                      <RadioGroup v-model="gatherForm.protective" style="width: 100%">
                        <Radio :label="1" disabled="false">优</Radio>
                        <Radio :label="2" disabled="false">良</Radio>
                        <Radio :label="3" disabled="false">差</Radio>
                        <Radio :label="4" disabled="false">无</Radio>
                      </RadioGroup>
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="景区/度假区名称" prop="scenicSpotName" style="width: 100%">
                      <Input v-model="gatherForm.scenicSpotName" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="景区/度假区等级" prop="scenicSpotGrade">
                      <Select
                        v-model="gatherForm.scenicSpotGrade"
                        disabled="false"
                        style="width: 100%"
                      >
                        <Option v-for="item in famousLevel" :value="item" :key="item">{{
                          item
                        }}</Option>
                      </Select>
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="游客接待量(万人/年)" style="width: 100%">
                      <Input v-model="gatherForm.visitorReception" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <Col :span="24">
                    <FormItem label="其他说明" prop="otherInstructionsTwo" class="qtsm">
                      <Input
                        v-model="gatherForm.otherInstructionsTwo"
                        clearable
                        type="textarea"
                        :rows="8"
                        disabled="false"
                      />
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
          <div class="form1-box">
            <Card style="margin-bottom: 10px">
              <p slot="title">
                <Icon type="ios-photos" style="color: #2d8cf0" />
                开发方向
              </p>
              <!-- <a href="#" slot="extra" @click.prevent="addkffx">
                <Icon type="ios-add-circle-outline" style="font-size: 24px" />
              </a> -->
              <Form
                ref="addDevelopForm"
                :label-width="150"
                :rules="developRule"
                :model="gatherForm"
                label-position="left"
                inline
              >
                <Row type="flex" v-for="(nav, index) in gatherForm.directionlist" :key="index">
                  <Col :span="12">
                    <FormItem label="规划文件名称" prop="planFileName" class="kffx">
                      <Input  type="textarea" :rows="5" v-model="nav.planFileName" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem
                      label="资源开发利用方向"
                      prop="utilizationDrection"
                      class="kffx"
                    >
                      <Input  type="textarea" :rows="5" v-model="nav.utilizationDrection" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <!-- <Col :span="2">
                    <Icon
                      type="md-trash"
                      class="delCal"
                      @click="deleteItem(index)"
                    />
                  </Col> -->
                </Row>
              </Form>
            </Card>
          </div>
          <div class="form1-box">
            <Card style="margin-bottom: 10px">
              <p slot="title">
                <Icon type="ios-photos" style="color: #2d8cf0" />
                评分列表
              </p>
              <Form
                ref="remarkForm"
                :label-width="150"
                label-position="left"
                :rules="remarkScoreRule"
                :model="remarkForm"
                inline
              >
                <Row type="flex">
                  <Col :span="12">
                    <FormItem label="观赏价值(0~30)" prop="ornamentalValue">
                      <Input
                        :max="30"
                        :min="0"
                        v-model="remarkForm.ornamentalValue"
                        disabled="false"
                        @on-blur="countRemarkScore"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="人文价值(0~25)" prop="humanisticValue">
                      <Input
                        :max="25"
                        :min="0"
                        v-model="remarkForm.humanisticValue"
                        disabled="false"
                        @on-blur="countRemarkScore"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="珍稀奇特度(0~15)" prop="rarityAndPeculiarity">
                      <Input
                        :max="15"
                        :min="0"
                        v-model="remarkForm.rarityAndPeculiarity"
                        disabled="false"
                        @on-blur="countRemarkScore"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="规模与丰度(0~10)" prop="scaleAndAbundance">
                      <Input
                        :max="10"
                        :min="0"
                        v-model="remarkForm.scaleAndAbundance"
                        disabled="false"
                        @on-blur="countRemarkScore"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="保存完整性(0~5)" prop="saveIntegrity">
                      <Input
                        :max="5"
                        :min="0"
                        v-model="remarkForm.saveIntegrity"
                        disabled="false"
                        @on-blur="countRemarkScore"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="知名度(0~10)" prop="popularity">
                      <Input
                        :max="10"
                        :min="0"
                        v-model="remarkForm.popularity"
                        disabled="false"
                        @on-blur="countRemarkScore"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="适游期(0~5)" prop="suitableTravelPeriod">
                      <Input
                        :max="5"
                        :min="0"
                        v-model="remarkForm.suitableTravelPeriod"
                        disabled="false"
                        @on-blur="countRemarkScore"
                      />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="环境与安全(-5~3)" prop="snvironmentAndSafety">
                      <Input
                        :max="3"
                        :min="-5"
                        v-model="remarkForm.snvironmentAndSafety"
                        disabled="false"
                        @on-blur="countRemarkScore"
                      />
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
          <div class="form1-box">
            <Card>
              <p slot="title">
                <Icon type="ios-photos" style="color: #2d8cf0" />
                单体评价
              </p>
              <div class="feature-info">
                旅游资源评价赋分标准请参照GB/T 18972-2017中“6旅游资源评价”的相关规定
              </div>
              <Form
                ref="addMarkForm"
                :rules="remarkRule"
                :label-width="150"
                label-position="left"
                inline
                :model="gatherForm"
              >
                <Row type="flex">
                  <Col :span="12">
                    <FormItem label="本单体得分" prop="monomerScore">
                      <Input v-model="gatherForm.monomerScore" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="本单体可能的等级" prop="maybeGrade" class="right-form-box">
                      <Input v-model="gatherForm.maybeGrade" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="填表人" prop="filledBy">
                      <Input v-model="gatherForm.filledBy" disabled />
                    </FormItem>
                  </Col>
                  <Col :span="12">
                    <FormItem label="联系电话" prop="contactNumber" class="right-form-box">
                      <Input v-model="gatherForm.contactNumber" clearable disabled="false" />
                    </FormItem>
                  </Col>
                  <Col :span="24">
                    <FormItem label="普查日期" prop="censusDate">
                      <Input v-model="gatherForm.censusDate" disabled="false" />
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
          <div style="height: 20px"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import detailItem from './detailItem';
export default detailItem;
</script>
<style lang="less" scoped>
.qtsm {
  /deep/ .ivu-form-item-label {
    padding: 66px 10px;
  }
  /deep/ textarea {
    resize: none;
  }
}
.kffx {
  /deep/ .ivu-form-item-label {
    padding: 40px 10px;
  }
  /deep/ textarea {
    resize: none;
  }
}
.main-box {
  width: 100%;
  height: 100%;
  background-color: white;
  overflow: hidden auto;
  padding: 20px;
  font-family: 'Microsoft YaHei';
  color: #000000;
}
.app {
  width: 100%;
  margin: 0 auto;
  .tab-box {
    position: fixed;
    top: 110px;
    width: 125rem;
    z-index: 1000;
    background-color: #fff;
    padding: 30px 0 0 16px;
  }
  /deep/.ivu-card-head {
    padding: 7px 16px !important;
  }
  .ivu-card-head p,
  .ivu-card-head-inner {
    font-weight: 100;
  }
  .w3 {
    width: 270px;
  }
  /deep/.ivu-form .ivu-form-item-label {
    white-space: nowrap;
  }

  .status-box {
    display: flex;
    background-color: pink;
    height: 8rem;
  }
  .type-box {
    font-size: 2.5rem;
    font-weight: 700;
    margin-left: 2rem;
  }
  .back-btn {
    position: absolute;
    right: 8rem;
    top: 2rem;
  }
  .h1-style {
    display: inline-block;
    font-size: 2.3rem;
    font-weight: 700;
    position: relative;
    left: 50%;
    margin-bottom: 20px;
    transform: translateX(-50%);
  }

  .rightTitle {
    border-radius: 2px;
    background: #3d92dc;
    width: 6px;
    height: 1.7rem;
    float: left;
    margin: 16px 7px 5px 9px;
  }
  .mark-box {
    height: 3.3rem;
    position: absolute;
    right: 12rem;
  }
  .form1-box {
    margin-left: 1.5rem;
    .text-area-box22 {
      border: 1px solid #bbb !important;
    }
    .feature-info {
      font-size: 12px;
      color: #aaa;
      position: relative;
      top: -27px;
    }
  }
  .form2-title {
    font-size: 1.5rem;
    font-weight: 500;
    margin: 0 0 10px 10px;
  }
  .viewer-box {
    margin-left: 8rem;
    .viewer-item {
      height: 10rem;
      margin: 1rem;
    }
  }

  .video-box {
    width: 25rem;
    height: 10rem;
    margin: 1rem;
    margin-left: 8rem;
  }
  .form2-box {
    margin-left: 1.5rem;
    .text-area-box {
      width: 80rem;
    }
    .feature-info {
      font-size: 12px;
      color: #aaa;
      position: relative;
      top: -27px;
    }
  }
  .contentCal {
    width: 100%;
    height: 79vh;
    // overflow: hidden auto;
    // min-width: 1024px;
    // overflow-x: auto !important;
  }
  ::-webkit-scrollbar {
    width: 0px !important;
    height: 0px !important;
  }
  .sub-box {
    display: flex;
    justify-content: center;

    .sub-box-btn {
      padding-left: 3rem;
      padding-right: 3rem;
      position: absolute;
      bottom: 1.5rem;
    }
  }
  /deep/ .ivu-form-item {
    width: 100%;
  }
  /deep/ .ivu-radio-group {
    width: 51rem;
    // margin-right: 15rem;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
    width: 51rem;
  }
  /deep/ .ivu-upload-drag {
    width: 100%;
    margin: 0 auto;
  }
  /deep/ .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
    width: 51rem;
  }
  /deep/ .ivu-form-item-label {
    font-size: 14px !important;
  }
  /deep/ .ivu-input-number {
    width: 42.5rem !important;
  }
  /deep/ .ivu-card-head {
    border-bottom: none;
  }
  /deep/ .ivu-card-bordered {
    border: 0;
  }
  .delCal {
    font-size: 24px;
    color: #2d8cf0;
    margin-left: 21px;
    cursor: pointer;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  /deep/ .ivu-form-inline .ivu-form-item {
    margin-right: 0;
  }
  /deep/ .ivu-form .ivu-form-item-label {
    border-right: 1px solid #bbb;
    // margin-bottom: -1px;
    // margin-left: -1px;
    // margin-right: -1px;
  }
  /deep/ .ivu-form-item-error-tip {
    padding-top: 0;
    padding-left: 6px;
  }
  /deep/ .ivu-form-item {
    margin-bottom: -1px;
    margin-right: -1px;
    margin-left: -1px;
  }
  /deep/ .ivu-form .ivu-form-item-label {
    line-height: 2rem;
    padding-left: 1rem;
  }
  /deep/ .ivu-form-item-content {
    position: relative;
    // top: 1rem;
  }
  /deep/ .ivu-form-inline .ivu-form-item {
    border: 1px solid #bbb;
  }
  /deep/ .ivu-input {
    border: 0 !important;
  }
  /deep/ .ivu-input[disabled] {
    background-color: rgba(255, 255, 255, 0) !important ;
  }
  /deep/ .ivu-selcet-selection {
    border: 0;
  }
  /deep/ .ivu-input-number {
    border: 0;
    background-color: rgba(0, 0, 0, 0);
    width: 99% !important;
  }
  /deep/ .ivu-select-disabled .ivu-select-selection {
    background-color: rgba(255, 255, 255, 0);
  }
  /deep/ .ivu-select-selection {
    border: 0;
  }
  /deep/ .ivu-input-number-disabled .ivu-input-number-input {
    background-color: rgba(0, 0, 0, 0);
  }
  /deep/ .ivu-col-span-12 {
    margin-right: -1px !important;
  }
  /deep/ .ivu-col-span-11 {
    margin-right: -1px;
  }
}
.title {
  margin-bottom: 10px;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
  margin-top: 24px;
}
.dw {
  padding-left: 78%;
}
.cjcontent {
  position: relative;
  width: 750px;
  /*  height: 600px;*/
  margin: 0 auto;
}
.cjcontent table {
  border-left: none !important;
  border-top: none !important;
  border: 1px solid #e8eaec;
}
.content1 {
  width: 43% !important;
}
.xmtext {
  font-size: 13px;
  border-left-width: 0px;
  padding-left: 30px;
}
textarea {
  border: none;
  line-height: 140%;
  display: table-cell;
  vertical-align: middle;
}
.text_area {
  border-width: 0px;
  background: white;
  border: none;
  height: 100%;
  width: 100%;
  vertical-align: middle;
  margin: 0 auto;
  outline: none;
  resize: none;
}
th {
  /*background-color: #abafbd;*/
  background-color: #f0f0f0;
  /*font-size: 15px;*/
}
td {
  /*font-size: 15px;*/
}
.app table td {
  height: 40px;
  border-bottom: none !important;
  border-right: none !important;
  font-size: 12px;
  border: 1px solid #e8eaec;
}
.app table th {
  height: 60px;
  border-bottom: none !important;
  border-right: none !important;
  font-size: 13px;
  border: 1px solid #e8eaec;
}

.ivu-checkbox + span,
.ivu-checkbox-wrapper + span {
  font-size: 12px !important;
}
.suggest-content {
  float: right;
  margin-bottom: 3px;
  right: 4.7rem;
  position: relative;
}
.often-suggest {
  border: 1px solid #e8eaec;
  height: 289px;
  width: 309px;
  float: left;
  position: absolute;
  right: 22px;
  top: 66px;
  overflow: auto;
}
.often-suggest ul li {
  margin: 10px;
  margin-left: 30px;
  overflow: auto;
  cursor: pointer;
}
.addOftenSuggest {
  position: absolute;
  left: 20px;
  bottom: 82px;
}
.ivu-form-inline .ivu-form-item {
  margin-right: 0;
}
/deep/ .ivu-input[disabled],
fieldset[disabled] .ivu-input {
  color: #515a6e !important;
}
.disable {
  background-color: #f3f3f3;
}
.brButton {
  display: block;
  position: fixed;
  bottom: 23px;
  left: 55%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  .brButton-btn {
    margin-right: 10px;
  }
}
.zhanwei {
  display: block;
  width: 107px;
  height: 38px;
  float: right;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/mapbase/detailItem/detailItem.vue